module.exports = __webpack_public_path__ + "img/kt1.a89f1cca.png";